import type { ElementType, ReactNode } from 'react';

/** 콘텐츠 column 폭 변형. */
export type WidthVariant = 'full' | 'lg' | 'md' | 'sm';

/**
 * WidthVariant → Tailwind max-width.
 * - `sm`   `max-w-sm`  — 폼·메시지(로그인·구독·약관·에러) 가독성 캡. (기본)
 * - `lg`   `max-w-5xl` — 앱 본문. `< lg`(태블릿·모바일)은 5xl 미만이라 꽉 차고, `lg+` 는 사이드바 + 5xl 캡.
 * - `md`   `max-w-2xl` — 중간 폭(신규). 실제 사용처 생기면 값 조정.
 * - `full` `max-w-full` — 꽉 채움(신규).
 */
const MAX_WIDTH: Record<WidthVariant, string> = {
  full: 'max-w-full',
  lg: 'max-w-5xl',
  md: 'max-w-2xl',
  sm: 'max-w-lg',
};

/**
 * 콘텐츠 column 제약 — 중앙 정렬 + max-width(`width` 변형).
 * `as` 로 semantic tag 보존(main / header / footer 등).
 */
interface ContentColumnProps {
  as?: ElementType;
  className?: string;
  children?: ReactNode;
  /** 콘텐츠 폭 변형. 기본 `'sm'`(폼·메시지 가독성 캡). */
  width?: WidthVariant;
}

export function ContentColumn({
  as: Tag = 'div',
  className = '',
  children,
  width = 'sm',
}: ContentColumnProps) {
  return (
    <Tag className={`mx-auto w-full ${MAX_WIDTH[width]} ${className}`.trimEnd()}>{children}</Tag>
  );
}
